import * as React from 'react';
import { forwardRef } from 'react';
const LabelPairedExclamationCaptionBoldIcon = ({ title, titleId, ...props }, ref) => (React.createElement("svg", { xmlns: 'http://www.w3.org/2000/svg', width: 2, height: 18, viewBox: '0 0 2 18', role: 'img', ref: ref, "aria-labelledby": titleId, ...props },
    title ? React.createElement("title", { id: titleId }, title) : null,
    React.createElement("g", null,
        React.createElement("path", { d: 'M1.563 4.813v6.75a.555.555 0 0 1-.563.562.54.54 0 0 1-.562-.562v-6.75c0-.305.234-.563.562-.563a.57.57 0 0 1 .563.563M1 14.75A.74.74 0 0 1 .25 14c0-.398.328-.75.75-.75.398 0 .75.352.75.75 0 .422-.352.75-.75.75' })),
    React.createElement("defs", null,
        React.createElement("clipPath", { id: '84afc83e0b6f9d5e5088386e42f51c1e__a' },
            React.createElement("path", { d: 'M0 0h2v18H0z' })))));
const ForwardRef = forwardRef(LabelPairedExclamationCaptionBoldIcon);
export default ForwardRef;
